import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPhoneNumber(phone: string): string {
    if (!phone) return "";

    // Remove todos os caracteres não numéricos
    let cleaned = phone.replace(/\D/g, '');

    // Remove o prefixo 55 se existir
    if (cleaned.startsWith("55")) {
        cleaned = cleaned.slice(2);
    }

    // Adiciona o prefixo +55
    if (!phone.startsWith("+55")) {
        cleaned = "55" + cleaned;
    }

    // Formata o número
    if (cleaned.length === 11) { // Celular
        return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
    } else if (cleaned.length === 10) { // Telefone fixo
        return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 8)}-${cleaned.slice(8)}`;
    }

    // Retorna o número limpo com prefixo se não conseguir formatar
    return "+" + cleaned;
}
